import React from 'react'

const Link = (props) => {
  return (
    <a href={ props.url } className={ props.className } target={ props.target || '_self' }>
      { props.title }
    </a>
  )
}

export default Link



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/rich_text/link/index.js